import $ from 'jquery';
import AOS from 'aos';

export default {
  init() {
    // @TODO: Justin figure out wtf this does
    const workHackItems = $('[data-work-index-animation-hack]');

    if (workHackItems.length) {
      const workItemDelayPromises = Array.from(workHackItems).map(el => {
        let initialDelay = el.getAttribute('data-aos-delay');
        let regularDelay = el.getAttribute('data-work-index-animation-hack');

        return new Promise(function(resolve) {
          setTimeout(function() {
            el.setAttribute('data-aos-delay', regularDelay);
            resolve();
          }, initialDelay);
        });
      });

      Promise.all(workItemDelayPromises).then(() => {
        AOS.refreshHard();
      });
    }
  }
};
